import React, { FC } from 'react';
import styles from './index.module.scss';
import TotalEnergy from './TotalEnergy';
import WorkshopStats from './WorkshopStats';

const CenterBox: FC = () => {
  return (
    <div className={styles.center_wrapper}>
      <div className={styles.center_top}>
        <TotalEnergy />
      </div>
      <div className={styles.center_bottom}>
        <WorkshopStats />
      </div>
    </div>
  );
};

export default CenterBox;
